<template>
  <h2 ref="text" v-bind:class="{'marginless': marginLess, 'quote-type': quoteType}">
    <span>
      <slot></slot>
    </span>
  </h2>
</template>

<script>
  import {TimelineMax, Power3} from 'gsap'
  import SplitText from '#/script/SplitText'
  import Clipboard from 'clipboard'

  export default {
    name: 'text-block',
    props: {
      revealTransition: {
        type: Boolean,
        default: false
      },
      marginLess: {
        type: Boolean,
        default: false
      },
      quoteType: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      if (this.revealTransition) {
        this.textSplit()
      }

      let clipboard = new Clipboard('.clip')

      clipboard.on('success', (e) => {
        let tl = new TimelineMax({paused: true})
        tl.to('.clip-message', 0.3, {opacity: 1})
        tl.to('.clip-message', 0.3, {opacity: 0, delay: 2})
        tl.restart()
      })
    },
    methods: {
      textSplit () {
        const textSplit = new SplitText(this.$refs.text, {type: 'lines, words'})

        const tl = new TimelineMax({paused: true})
        tl.set(textSplit.lines, {overflow: 'hidden'}, 0)
        tl.staggerFrom(textSplit.words, 1, {y: 80, ease: Power3.easeOut, onComplete: () => { textSplit.revert() }}, 0.02, 0.8)
        tl.restart()
      }
    }
  }
</script>

<style lang="scss" scoped>
  h2 {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    align-items: flext-start;
    cursor: default;
    color: $color-darkgrey;
    min-height: 600px;

    @include device(mobile) {
      min-height: 300px;
    }

    & span {
      display: block;
      max-width: 480px;

      & u, & a {
        color: $color-black;
        text-decoration: none;
        cursor: pointer;
        text-shadow: 0 1px 0 #fff,
                     0 2px 0 #fff,
                     0 4px 0 #fff,
                     -2px 1px 0 #fff,
                     -2px 2px 0 #fff,
                     -2px 4px 0 #fff,
                     2px 1px 0 #fff,
                     2px 2px 0 #fff,
                     2px 4px 0 #fff;
        box-shadow: inset 0 -2px 0 #eee;
        transition: color 0.1s linear;

        &::selection {
          background-color: royalblue;
          color: #fff;
          text-shadow: none;
        }

        &:hover {
          color: royalblue;
        }
      } // u
    } // span

    & em {
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      color: royalblue;
      opacity: 0;
    }

    &.marginless {
      min-height: auto;
    }

    &.quote-type {
     & span {
       max-width: 600px;

       & cite {
         display: block;
         font-style: normal;
         font-size: 1rem;
         margin-top: 10px;
         opacity: 0.4;
       }
     } 
    }
  } // h2
</style>



// WEBPACK FOOTER //
// src/components/TextBlock.vue